import React, { useState, useEffect, useContext, Component } from 'react';
import { Link, useNavigate } from 'react-router-dom'
import Swal from 'sweetalert2'; // Import SweetAlert2

import AccountSidebar from '../../components/AccountSidebar';
import { toast } from 'react-hot-toast';
import { useDispatch } from 'react-redux';
import { authActions } from '../../../redux/store';
import axios from 'axios';
import axiosInstance, { weburl } from '../../../axiosInstance';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import withReactContent from 'sweetalert2-react-content'; // Import React components for SweetAlert2
import { useBlogContext } from '../../../fetchdata/BlogContext';

 
import { Helmet } from 'react-helmet';
import getCookie from '../../../helper/getCookie';
import getDecryptData from '../../../helper/getDecryptData';
const MySwal = withReactContent(Swal); // Create a SweetAlert2 instance with React components

const Account = () => {
   const { Headers} = useBlogContext();

    const decryptdatajson =  getDecryptData();


  const navigate = useNavigate();
  const dispatch = useDispatch();

  // const isLoginFromLocalStorage = localStorage.getItem('token') ? true : false;
  const isLoginFromLocalStorage =  getCookie('token') ? true : false;

  const [isLogin, setIsLogin] = useState(isLoginFromLocalStorage);

  const [isLoginForm, setIsLoginForm] = useState(true); // State to manage which form to display

  const [IfLogin, setIfLogin] = useState(true); // State to manage which form to display



  const toggleForm = () => {
    setIsLoginForm(prevState => !prevState); // Toggle between login and signup forms
  };


  useEffect(() => {
    // console.log(isLoginFromLocalStorage, 'isLoginFromLocalStorage')

    const checkUserToken = async () => {
      console.log('Effect is running');
      // Check if this is printed multiple times
     
      // const usertoken = localStorage.getItem('token');

      const usertoken =  getCookie('token');
      
      if (!usertoken) {
        toast.error("Please Login First");
        navigate('/');

      }

    }
    checkUserToken();
  }, [dispatch, navigate]);




  const [Order, setOrder] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [OrderPlace, setOrderPlace] = useState('');
  const [MYuser, setMYuser] = useState('');
    const [formData, setFormData] = useState([]);


  // const userId = localStorage.getItem('userId');
  const userId = getCookie('userId');

  const getUserOrders = async () => {

    try {
  
    const id = decryptdatajson?._id;

      const { data } = await axiosInstance.get(`/user-orders/${id}`);
      // console.log(id);
      if (data?.success) {
        setOrder(data?.userOrder.orders);
        setOrderPlace(data?.userOrder.orders.length)
      }
      setIsLoading(false); // Set loading state to false after fetching data
      setIfLogin(false)
    } catch (error) {
      console.log(error);
      setIsLoading(false); // Set loading state to false in case of an error

    }
  };

  useEffect(() => {
    // This useEffect runs whenever the 'blog' state variable changes
    // console.log(Order); // Log the updated 'blog' state
  }, [Order]); // Dependency array with 'blog' ensures the effect runs when 'blog' state changes


  const [showModal, setShowModal] = useState(false);

  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);


  function formatDate(dateString) {
    const options = { year: 'numeric', month: 'short', day: 'numeric' };
    return new Date(dateString).toLocaleDateString('en-US', options);
  }


  useEffect(() => {

    if (!IfLogin) {
      const getUsernameAndEmailFromLocalStorage = () => {
       // const userString = localStorage.getItem('user');
        const userString =  getCookie('user');

        if (userString) {
          const { username, email } = JSON.parse(userString);
          return { username, email };
        }
        return null;
      };

      // Retrieve username and email from local storage user data
      const { username, email } = getUsernameAndEmailFromLocalStorage();
      setMYuser(username);

    }
    getUserOrders();
  }, []); // Empty dependency array ensures that the effect runs once after the initial render


    const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "checkbox" ? checked : value,
    }));

  };



        // Function to handle delete
    const handleCancelOrder = (categoryId) => {
      if(!formData.comment || formData.comment === ''){
     toast.error('Comment is required');
       return null;
      }
  
      const mycomment = `Cancelled by user: ${formData.comment}`;
  
      MySwal.fire({
        title: 'Are you sure?',
        text: 'You will not be able to recover this data!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, Cancel it!',
        cancelButtonText: 'No, cancel!',
        reverseButtons: true,
        customClass: {
          popup: 'custom-swal-popup', // Add a class to the entire dialog
          confirmButton: 'btn-primary', // Add a class to the confirm button
        },
      }).then((result) => {
        if (result.isConfirmed) {
   
      axiosInstance.put(`/cancel-order/${categoryId}`, { comment: mycomment }) 
            .then(() => {
              // Refresh the data or update the state after successful deletion
              getUserOrders();
              toast.success("Cancel Order Successfully!");
            setFormData([]);
  
            })
            .catch((error) => {
              console.error('Error Mark Done:', error);
              toast.error("Error Cancel Order");
   
            });
        }
      });
    };
  

    const [submitLoading, setSubmitLoading] = useState(false);

  
  const handleSubmit = async (order_id,total) => {

 
    // Start loading before the submission process
    setSubmitLoading(false);
 
      // Prepare data for submission
      const updatedFormData = {
        orderId: order_id,
        totalAmount: total,
       };

      try {

         
        // Send the data to the backend

        const data = await axiosInstance.post(`/order-payment`, updatedFormData);

        console.log('dataaa', data)
        const { success, Order } = data.data;
        if (success) {
 
          console.log('buyPlan',Order)
          const options = {
            key: Headers.keyId,
            amount: total ,
            currency: "INR",
            name: "Thehelply",
            description: "thehelply.com Find Local Service Professionals Near You!",
            image: Headers.meta_logo,
            order_id: Order.razorpay_order_id,
            callback_url: `${weburl}order-payment-verification`,
            // prefill: {
            //   name: "test gupta",
            //   email: "test@gmail.com",
            //   contact: "1234567890",
            // },
            notes: {
              address: "razorapy official",
            },
            theme: {
              color: "#3399cc",
            },
          };
          const razor = new window.Razorpay(options);
          razor.open();
 

        } else {
          toast.error(data.message || "Something went wrong. Please try again.");
        }
      
 
        
      } catch (error) {
        console.error("Error On payment:", error);
      } finally {
        // Stop loading after the submission process finishes
        setSubmitLoading(true);
      }

 
  };


  return (
    <>

      <Header />

      <Helmet>
        <title> Account Order | {window.location.hostname}</title>

      </Helmet>

      {isLogin && <>
        <div className="user-dasboard bg-light" >

          <div className="container pt-4">
            <div className="row pb-4">

              <AccountSidebar />

              <div className="col-lg-9 my-lg-0 my-1">
                <div id="main-content" className="bg-white border p-3 rounded">

                  <h4 className="text-uppercase">My orders</h4>



                  {isLoading ? (
                    // Display loading skeletons while data is being fetched
                    Array.from({ length: 2 }).map((_, index) => (
                      <div className="col-md-12" key={index}>

                        <div className="skeleton mb-3" style={{ height: 154, borderRadius: 2 }} />

                      </div>
                    ))
                  ) :
                    (Order.map(Order => (
                      <>


                        <div className="order my-3 bg-light-border">
                          <div className="row">
                            <div className="col-lg-4">
                              <div className="d-flex flex-column justify-content-between order-summary">
                                <div className="d-flex align-items-center">
                                  <div className="text-uppercase">Order #{Order.orderId}</div>
                                  
                                  <div className="blue-label ms-auto text-uppercase">
                                    {Order.mode}
                                  </div>
                                </div>

                                <div className="fs-8"> {formatDate(Order.createdAt)}</div>

                              </div>
                            </div>
                            <div className="col-lg-8">
                              <div className="d-sm-flex align-items-sm-start justify-content-sm-between"> 
                                <div className="status">Status:  {
  Order.status === 0 ? (<>Cancelled</>) :
    Order.status === 1 ? 'Placed' :
      Order.status === 2 ? 'Accepted' :
        Order.status === 3 ? 'Scheduled' :
          Order.status === 4 ? 'On the Way' :
            Order.status === 5 ? 'Started' :
              Order.status === 6 ? 'In Progress' :
                Order.status === 7 ? 'Completed' :
                  Order.status === 8 ? 'Reviewed' :
                    'Unknown'
}
 </div>




     {(Order.status === 1 || Order.status === 2 ) && 
                         <>

                                               <div className="dropdown">
  <button
    className="btn btn-danger dropdown-toggle btn-sm "
    type="button"
    data-bs-toggle="dropdown"
    aria-expanded="false"
  >
   Cancel Order
  </button>
  <ul className="dropdown-menu p-0">
   <div className="p-2 rounded bg-light   input-sm">
    <label for="comment"> Comment <span className='text-danger'> (required) </span></label>
                            <textarea
                              
                               id="comment"
                              className="form-control"
                              name="comment"
                              value={formData.comment}
                              onChange={handleChange}
                            />
                            <button className="btn bg-dark text-white dropdown-toggle btn-sm mt-3" onClick={()=>{handleCancelOrder(Order?._id)}}>
                              Submit
                            </button>

                          </div>
  </ul>
</div>
 
                         </>}
 
 {Order.status === 7 && ( 
 Order.payment === 1 ? <button className="btn btn-success btn-sm me-2 text-white text-uppercase" >
                                 Paid
                                </button> :
   <button className="btn btn-dark btn-sm me-2 text-white text-uppercase"  onClick={()=>{handleSubmit(Order._id,Order.totalAmount)}}>
                                  Pay Now
                                </button>)
 }
                                <Link className="btn  btn-sm btn-dark text-white text-uppercase" to={`/account/order/${decryptdatajson._id}/${Order._id}`}>
                                  order info
                                </Link>
                              </div>

                              <div className="progressbar-track">
                              <ul className="progressbar">
  <li id="step-1" className={`text-muted ${parseInt(Order.status) >= 1 ? 'text-success' : ''}`}>
    <i className="bi bi-hourglass-split" /> {/* Pending */}
   </li>

  <li id="step-2" className={`text-muted ${parseInt(Order.status) >= 2 ? 'text-success' : ''}`}>
    <i className="bi bi-person-check" /> {/* Accepted */}
   </li>
 
 
  <li id="step-5" className={`text-muted ${parseInt(Order.status) >= 5 ? 'text-success' : ''}`}>
    <i className="bi bi-play-circle" /> {/* Started */}
   </li>

 
  <li id="step-7" className={`text-muted ${parseInt(Order.status) >= 7 ? 'text-success' : ''}`}>
    <i className="bi bi-check2-circle" /> {/* Completed */}
   </li>
 
</ul>

                                <div id="tracker" />
                              </div>

                            </div>
                          </div>
                        </div>


                      </>
                    ))
                    )}


                </div>
              </div>
            </div>
          </div>

        </div>
      </>}




      <Footer />


    </>
  )
}

export default Account